import {useQueryClient} from '@tanstack/react-query'
import {useCallback} from 'react'

import {updateMemexItemWitNewRowPositionInQueryClient} from './query-client-api'

export interface PreviousItemPosition {
  /**
   * The id of the item directly before the item that was moved.
   * If the item that was moved is now the top, we represent this with an empty string ''
   */
  previousItemId: number | ''
  /**
   * The old index in the list of the item that was just moved.
   */
  previousMovingItemIndex?: number
}

type SetNewRowPositionHookReturnType = {
  /**
   * Updates the position of an item in the list of items locally, and then makes a request to the server
   * @param id The id of the item which we are now moving
   * @param index The index in the list of items where we are attempting to move this item to
   * @return Some metadata about the item that was just moved
   */
  setNewRowPosition: (id: number, index: number) => PreviousItemPosition
}

export const useSetNewRowPosition = (): SetNewRowPositionHookReturnType => {
  const queryClient = useQueryClient()

  const setNewRowPosition = useCallback(
    (id: number, index: number) => {
      return updateMemexItemWitNewRowPositionInQueryClient(queryClient, id, index)
    },
    [queryClient],
  )

  return {setNewRowPosition}
}
